import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, isDarkMode }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(), 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'success' 
    ? (isDarkMode ? 'bg-green-900/20 border-green-800' : 'bg-green-50 border-green-100')
    : (isDarkMode ? 'bg-red-900/20 border-red-800' : 'bg-red-50 border-red-100');

  const textColor = type === 'success' ? 'text-green-500' : 'text-red-500';

  return (
    <div className={`fixed bottom-8 right-8 z-[100] flex items-center gap-3 px-4 py-3 rounded-xl border shadow-lg animate-in slide-in-from-right-full duration-300 ${bgColor}`}>
      {type === 'success' ? <CheckCircle size={18} className={textColor} /> : <XCircle size={18} className={textColor} />}
      <span className={`text-sm font-medium ${isDarkMode ? 'text-stone-200' : 'text-stone-800'}`}>{message}</span>
      <button onClick={onClose} className="ml-2 text-stone-400 hover:text-stone-600 transition-colors">
        <X size={14} />
      </button>
    </div>
  );
};

export default Toast;